import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { usePathname, useSearchParams } from 'next/navigation';
import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import { selectCurrentUser } from 'features/auth/slice';

import Discord from 'features/shared/Discord';
import Tabs from './Tabs';
import ShareModal from 'features/solutions/Share/Modal';

import Start from './Start';
import Downloads from './Downloads';
import Submit from './Submit';
import Solutions from './Solutions';

import { useQueryTabs, useModal } from '@frontendmentorio/design-system-v2';

export default function Show({ articles, challenge }) {
  const currentUser = useSelector(selectCurrentUser);

  const { activeTab, handleChange, options } = useQueryTabs([
    { label: 'Step 1: Start challenge', value: '' },
    { label: 'Step 2: Download assets', value: 'downloads' },
    { label: 'Step 3: Submit solution', value: 'submit' },
    { label: 'Step 4: Review solutions', value: 'solutions' },
  ]);

  const {
    data: { data: attempts },
    isLoading,
  } = useFetchInfinite(
    currentUser
      ? `/api/v3/learner/solutions?filter=challenge|${challenge.id}`
      : null
  );

  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const shareModal = useModal();

  useEffect(() => {
    if (!router.query.share) return;
    if (isLoading || !attempts?.length) return;

    const params = new URLSearchParams(searchParams.toString());

    params.delete('share');
    router.replace(`${pathname}?${params}`);
    shareModal.open?.();
  }, [attempts, isLoading, shareModal]);

  return (
    <>
      <div className="px-5 py-6">
        <Tabs
          activeTab={activeTab}
          ariaLabel="Select appropriate step"
          onChange={handleChange}
          options={options}
        />

        <div className="container-xl flex flex-col gap-8">
          {activeTab === '' && <Start challenge={challenge} />}
          {activeTab === 'downloads' && (
            <Downloads articles={articles} challenge={challenge} />
          )}
          {activeTab === 'submit' && <Submit challenge={challenge} />}
          {activeTab === 'solutions' && <Solutions challenge={challenge} />}

          <Discord />
        </div>
      </div>

      {attempts?.length > 0 && (
        <ShareModal
          emoji="🎉"
          modal={shareModal}
          solution={attempts[0]}
          subtitle="Now it's time to share your creation with the world"
          title="You completed the challenge!"
        />
      )}
    </>
  );
}
